// extracted by mini-css-extract-plugin
export default {"wrapper_button":"styles_wrapper_button__CDXc5","btn_pulse":"styles_btn_pulse__pZijy","pulse":"styles_pulse__nyxbE","textBtn":"styles_textBtn__-rUlJ"};